import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

// ============================== Start Views ==============================
// Home
import Home from "../views/Home.vue";

// ********** Children
import HomePage from "../views/children/HomePage.vue";

// ========== Start Profiles ==========

// ========== End Profiles ==========

// ============================== START:: CRUDS ==============================

// ========== Start:: Static Screens ==========
// import StaticScreens from "../views/children/StaticScreens/Home.vue";
// ========== End:: Static Screens ==========

// ========== Start:: Reference ==========
// import Reference from "../Reference/Reference.vue";
// ========== End:: Reference ==========

// ********** Auth
import Login from "../views/Auth/Login.vue";

// ********** NotFound
import NotFound from "../views/NotFound.vue";
// ============================== End Views ==============================

// Vuex store
import store from "../store/index";
let router = null;
window.rootRouter = router = new VueRouter({
  mode: "history",
  base: "/",
  routes: [
    // Main
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomePage",
          component: HomePage,
        },
        // ============================== Start CRUDS ==============================
        // ******* Start Countries *******

        {
          path: "/countries",
          component: () => import("../views/children/CRUDS/Countries/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCountries",
              component: () =>
                import("../views/children/CRUDS/Countries/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CountryShow",
              component: () =>
                import("../views/children/CRUDS/Countries/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CountryEdit",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CountryAdd",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
            },
          ],
        },

        // ******* End Countries *******
        // ******* Start Clients *******

        {
          path: "/clients",
          component: () => import("../views/children/CRUDS/Clients/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllClients",
              component: () =>
                import("../views/children/CRUDS/Clients/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "ClientShow",
              component: () =>
                import("../views/children/CRUDS/Clients/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "ClientEdit",
              component: () =>
                import("../views/children/CRUDS/Clients/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ClientAdd",
              component: () =>
                import("../views/children/CRUDS/Clients/Form.vue"),
            },
          ],
        },

        // ******* End Clients *******
        // ******* Start Pages *******
        {
          path: "/pages",
          component: () => import("@/views/children/CRUDS/Pages/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPages",
              component: () =>
                import("@/views/children/CRUDS/Pages/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Pageshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Pages/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "PagesEdit",
              component: () => import("@/views/children/CRUDS/Pages/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PagesAdd",
              component: () => import("@/views/children/CRUDS/Pages/Form.vue"),
            },
          ],
        },
        // ******* End Pages *******
        // Start Orders
        {
          path: "/orders",
          component: () => import("@/views/children/CRUDS/Orders/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOrders",
              component: () =>
                import("@/views/children/CRUDS/Orders/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "Orderhow",
              component: () => import("@/views/children/CRUDS/Orders/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "OrderEdit",
              component: () => import("@/views/children/CRUDS/Orders/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OrderAdd",
              component: () => import("@/views/children/CRUDS/Orders/Form.vue"),
            },
          ],
        },
        // End Orders
        // ******* Start Faqs *******
        {
          path: "/faqs",
          component: () => import("../views/children/Settings/Faq/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "faqs",
              component: () =>
                import("../views/children/Settings/Faq/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "faqsShow",
            //   component: () =>
            //     import("../views/children/Settings/Faq/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "faqsEdit",
              component: () =>
                import("../views/children/Settings/Faq/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "faqsAdd",
              component: () =>
                import("../views/children/Settings/Faq/Form.vue"),
            },
          ],
        },
        // ******* End Faqs *******
        // ******* Start Transactions *******
        {
          path: "/transactions",
          component: () =>
            import("../views/children/CRUDS//Transactions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "transactions",
              component: () =>
                import("../views/children/CRUDS/Transactions/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "transactionsShow",
              component: () =>
                import("../views/children/CRUDS/Transactions/Show.vue"),
              props: true,
            },
            // Edit
            // {
            //   path: "edit/:id",
            //   name: "faqsEdit",
            //   component: () =>
            //     import("../views/children/CRUDS/Faq/Form.vue"),
            //   props: true,
            // },
            // Add
            // {
            //   path: "add",
            //   name: "faqsAdd",
            //   component: () =>
            //     import("../views/children/CRUDS/Faq/Form.vue"),
            // },
          ],
        },
        // ******* End Transactions *******
        {
          path: "/contacts",
          component: () =>
            import("../views/children/CRUDS/ContactMessages/ShowAll.vue"),
          children: [
            // Show Single
            {
              path: "show-all",
              name: "contactShow",
              component: () =>
                import("../views/children/CRUDS/ContactMessages/ShowAll.vue"),
              props: true,
            },
          ],
        },
        // ******* Start employees *******
        {
          path: "/employees",
          component: () => import("../views/children/CRUDS/Employees/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllEmployees",
              component: () =>
                import("../views/children/CRUDS/Employees/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "EmployeeShow",
              component: () =>
                import("../views/children/CRUDS/Employees/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "EmployeeEdit",
              component: () =>
                import("../views/children/CRUDS/Employees/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "EmployeeAdd",
              component: () =>
                import("../views/children/CRUDS/Employees/Form.vue"),
            },
          ],
        },
        // ******* End employees *******

        // ******* Start blacklist *******
        {
          path: "/blacklist",
          component: () => import("@/views/children/CRUDS/BlackList/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllBlackList",
              component: () =>
                import("@/views/children/CRUDS/BlackList/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "SubscribersShow",
            //   component: () => import("@/views/children/CRUDS/Subscribers/Show.vue"),
            //   props: true,
            // },
          ],
        },
        // End blacklist
        // ******* Start Hedayat *******
        {
          path: "/hedayat",
          component: () => import("../views/children/CRUDS/Hedayat/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllHedayat",
              component: () =>
                import("../views/children/CRUDS/Hedayat/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "HedayatShow",
              component: () =>
                import("../views/children/CRUDS/Hedayat/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End Hedayat *******
        // ******* Start Comments *******
        {
          path: "/comments",
          component: () => import("../views/children/CRUDS/Comments/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllComments",
              component: () =>
                import("../views/children/CRUDS/Comments/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CommentsShow",
              component: () =>
                import("../views/children/CRUDS/Comments/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End Comments *******
        // ******* Start Categories *******
        {
          path: "/categories",
          component: () => import("@/views/children/CRUDS/Categories/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCategories",
              component: () =>
                import("@/views/children/CRUDS/Categories/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "categoryShow",
              component: () =>
                import("@/views/children/CRUDS/Categories/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "categoryEdit",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "categoryAdd",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
            },
          ],
        },
        // ******* End Categories *******
        // ******* Start SubCategories *******
        {
          path: "/subcategories",
          component: () =>
            import("@/views/children/CRUDS/SubCategories/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSubCategories",
              component: () =>
                import("@/views/children/CRUDS/SubCategories/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "subcategoryShow",
              component: () =>
                import("@/views/children/CRUDS/SubCategories/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "subcategoryEdit",
              component: () =>
                import("@/views/children/CRUDS/SubCategories/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "subcategoryAdd",
              component: () =>
                import("@/views/children/CRUDS/SubCategories/Form.vue"),
            },
          ],
        },
        // ******* End SubCategories *******
        // ******* Start Products *******
        {
          path: "/products",
          component: () => import("@/views/children/CRUDS/Products/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllProducts",
              component: () =>
                import("@/views/children/CRUDS/Products/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "productShow",
              component: () =>
                import("@/views/children/CRUDS/Products/Show.vue"),
              props: true,
            },
            // Show Single
            {
              path: "showchildrens/:id",
              name: "productChildrensShow",
              component: () =>
                import("@/views/children/CRUDS/Products/ShowAllChildren.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "productEdit",
              component: () =>
                import("@/views/children/CRUDS/Products/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "productAdd",
              component: () =>
                import("@/views/children/CRUDS/Products/Form.vue"),
            },
          ],
        },
        // ******* End Products *******
        // ******* Start Tags *******
        {
          path: "/tags",
          component: () => import("@/views/children/CRUDS/Tags/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTags",
              component: () =>
                import("@/views/children/CRUDS/Tags/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "tagEdit",
              component: () => import("@/views/children/CRUDS/Tags/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "tagAdd",
              component: () => import("@/views/children/CRUDS/Tags/Form.vue"),
            },
          ],
        },
        // ******* End Products *******
        // ******* Start Sliders *******
        {
          path: "/sliders",
          component: () => import("@/views/children/CRUDS/Sliders/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSliders",
              component: () =>
                import("@/views/children/CRUDS/Sliders/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "sliderShow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Sliders/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "sliderEdit",
              component: () =>
                import("@/views/children/CRUDS/Sliders/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "sliderAdd",
              component: () =>
                import("@/views/children/CRUDS/Sliders/Form.vue"),
            },
          ],
        },
        // ******* End Sliders *******
        // ******* Start Services *******
        {
          path: "/service",
          component: () => import("@/views/children/CRUDS/Services/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllServices",
              component: () =>
                import("@/views/children/CRUDS/Services/ShowAll.vue"),
            },
          ],
        },
        // ******* End Services *******
        // ******* Start notifications *******
        {
          path: "/notifications",
          component: () =>
            import("@/views/children/CRUDS/notifications/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-notifications",
              component: () =>
                import("@/views/children/CRUDS/notifications/ShowAll.vue"),
            },
            // Show Single

            {
              path: "add",
              name: "add-notification",
              component: () =>
                import("@/views/children/CRUDS/notifications/Form.vue"),
            },
          ],
        },
        // ******* End notifications *******
        // ******* Start Subscribers *******
        {
          path: "/subscribers",
          component: () =>
            import("@/views/children/CRUDS/Subscribers/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSubscribers",
              component: () =>
                import("@/views/children/CRUDS/Subscribers/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "SubscribersShow",
            //   component: () => import("@/views/children/CRUDS/Subscribers/Show.vue"),
            //   props: true,
            // },
          ],
        },
        // ******* End Subscribers *******
        // ******* Start  Admins *******
        {
          path: "/admins",
          component: () => import("@/views/children/CRUDS/Admins/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAdmins",
              component: () =>
                import("@/views/children/CRUDS/Admins/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "adminShow",
              component: () => import("@/views/children/CRUDS/Admins/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "adminEdit",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "adminAdd",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
            },
          ],
        },
        // ******* End  Admins *******
        // ******* Start  Permission *******
        {
          path: "/permissions",
          component: () =>
            import("@/views/children/CRUDS/Permissions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPermissions",
              component: () =>
                import("@/views/children/CRUDS/Permissions/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "EditPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
              props: true,
            },
            // Edit
            // {
            //   path: "add",
            //   name: "AddPermission",
            //   component: () =>
            //     import("@/views/children/CRUDS/Permissions/Form.vue"),
            // },
          ],
        },
        // ******* End  Permission *******
        // ******* Start  roles *******
        {
          path: "/roles",
          component: () => import("@/views/children/CRUDS/Roles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-roles",
              component: () =>
                import("@/views/children/CRUDS/Roles/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
              props: true,
            },
            {
              path: "edit-role/:id",
              name: "edit-roles",
              component: () =>
                import("@/views/children/CRUDS/Roles/FormEdit.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
            },
          ],
        },
        // ******* End  roles *******
        // ========== Start Settings ==========
        {
          path: "/settings",
          component: () => import("../views/children/Settings/Home.vue"),
          children: [
            {
              path: "",
              name: "mainSettings",
              component: () => import("../views/children/Settings/General.vue"),
            },
            // {
            //   path: "social",
            //   name: "socialSettings",
            //   component: () => import("../views/children/Settings/Social.vue"),
            // },
            // {
            //   path: "sms",
            //   name: "sms",
            //   component: () =>
            //     import("../views/children/Settings/SmsServices.vue"),
            // },
            // {
            //   path: "order-setting",
            //   name: "order-setting",
            //   component: () => import("../views/children/Settings/Orders.vue"),
            // },
            // {
            //   path: "app-links",
            //   name: "app-links",
            //   component: () =>
            //     import("../views/children/Settings/AppLinks.vue"),
            // },
          ],
        },
        // ========== End Settings ==========

        // ========== Start Profiles ==========
        {
          path: "/profile",

          component: () => import("@/views/children/adminProfile/Home.vue"),
          children: [
            {
              path: "show",
              name: "showProfile",
              component: () => import("@/views/children/adminProfile/Show.vue"),
            },
            {
              path: "edit",
              name: "editProfile",
              component: () => import("@/views/children/adminProfile/Form.vue"),
            },
            {
              path: "password",
              name: "changePassword",
              component: () =>
                import("@/views/children/adminProfile/ChangePassword.vue"),
            },
          ],
        },
        // ========== End Profiles ==========
        // ========== Start Warehouses ==========
        {
          path: "/warehouses",
          component: () => import("@/views/children/CRUDS/Warehouses/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllWarehouses",
              component: () =>
                import("@/views/children/CRUDS/Warehouses/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "warehouseShow",
              component: () =>
                import("@/views/children/CRUDS/Warehouses/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "warehouseEdit",
              component: () =>
                import("@/views/children/CRUDS/Warehouses/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "warehouseAdd",
              component: () =>
                import("@/views/children/CRUDS/Warehouses/Form.vue"),
            },
          ],
        },
        // ========== End Warehouses ==========
        // ******* Start Offers *******
        {
          path: "/offers",
          component: () => import("@/views/children/CRUDS/Offers/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOffers",
              component: () =>
                import("@/views/children/CRUDS/Offers/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "offerShow",
              component: () => import("@/views/children/CRUDS/Offers/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "offerEdit",
              component: () => import("@/views/children/CRUDS/Offers/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "offerAdd",
              component: () => import("@/views/children/CRUDS/Offers/Form.vue"),
            },
          ],
        },
        // ******* End Offers *******
        // ========== Start Home Screen Settings ==========
        {
          path: "/home-screen-settings",
          component: () => import("../views/children/HomeScreen/Home.vue"),
          children: [
            {
              path: "",
              name: "homeScreenSettings",
              component: () =>
                import("../views/children/HomeScreen/General.vue"),
            },
          ],
        },
        // ========= End Home Screen Settings ==============================
      ],
    },

    {
      path: "/permission-required",
      name: "permission-required",
      component: () => import("../views/PermissionRequired.vue"),
    },

    //  =========== Start Redirects ===============
    {
      path: "/countries",

      redirect: () => {
        return { path: "/countries/show-all" };
      },
    },
    {
      path: "/about",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    {
      path: "/about/add",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms/add",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy/add",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    //  =========== End  Redirects ===============
    // Auth
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    // NotFound
    { path: "/:notFound(.*)", name: "NotFound", component: NotFound },
  ],
});

router.beforeEach((to, _2, next) => {
  const token = store.getters["auth_module/currentUser"].token;
  console.log("[Router Guard] Token:", token, "Route:", to.name);
  if (to.name !== "Login" && !token) {
    next({ name: "Login" });
  } else if (to.name == "Login" && token) {
    next("/");
  } else {
    next();
  }
});

export default router;
